import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { add_user_api, get_user_details, user_delete_api, user_update_api } from '../api/api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api/url';
import { PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import Loader from '../Loader/Loader';
import $ from 'jquery';
import FormError from '../components/FormError';


function DeliveryBoy() {
    const { loader, setLoader } = useContext(MyContext);

    const add_close_Ref = useRef(null);
    const update_close_Ref = useRef(null);
    const input_password_Ref = useRef(null);
    const [fileListIns, setFileListIns] = useState([]);
    const [deliveryBoy, setDeliveryBoy] = useState([]);
    const [inputUser, setInputUser] = useState({

        username: "",
        user_id: "",
        firstname: "",
        lastname: "",
        mobile_no: "",
        email: "",
        password: "",
        user_profile: "",
        delete_profile_image: false,
    });
    const [deliveryBoyStatus, setDeliveryBoyStatus] = useState('1');
    const [filterDeliveryBoyData, setFilterDeliveryBoyData] = useState([]);
    const [formError, setFormError] = useState({
        username: "",
        mobile_no: "",
        password: "",
    })

    useEffect(() => {
        fetch_delivery_boy_details();
    }, []);


    useEffect(() => {
        if (deliveryBoy.length > 0) {
            filter_data();
        }
    }, [deliveryBoy, deliveryBoyStatus]);



    const filter_data = () => {
        const filter = deliveryBoy.filter((obj) => obj.status == deliveryBoyStatus)
        setFilterDeliveryBoyData(filter);
    };


    const change_deliver_boy_status = () => {
        fetch_delivery_boy_details();
        setDeliveryBoyStatus(deliveryBoyStatus == '0' ? '1' : '0');
    }


    const handle_change = (e) => {
        const { name, value, files } = e.target;

        if (name === 'mobile_no' && value.length > 10) {
            return; // Prevent updating state if the length exceeds 10
        }

        setInputUser({
            ...inputUser,
            [name]: files && files.length > 0 ? files[0] : name === "mobile_no" ? value.replace(/[^0-9]/g, "") : value || ""
        });
    };


    // random password generate 
    const generateRandomNumber = () => {

        input_password_Ref.current.value = "";
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < 8; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }

        setInputUser({
            ...inputUser,
            password: result
        });
        input_password_Ref.current.value = result;
    };



    const generate_user_name = () => {
        if (inputUser.firstname && inputUser.lastname && !inputUser.username) {
            const randomDigits = Math.floor(Math.random() * 900) + 100; // Generates a 3-digit random number
            const username = `${inputUser.firstname.toLowerCase()}_${inputUser.lastname.toLowerCase()}${randomDigits}`;
            setInputUser({
                ...inputUser,
                username: username
            })
        }
    };



    //add user
    const add_user_api_call = async () => {
        const { username,
            mobile_no,
            password, } = inputUser

        const errors = {};

        if (!username) {
            errors.username = 'Please Enter Username!'
        }
        if (!mobile_no) {
            errors.mobile_no = 'Please Enter Mobile No!'
        }
        if (!password) {
            errors.password = 'Please Enter Password!'
        }
        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {
            const res = await add_user_api(inputUser);
            if (res.status === 200) {
                fetch_delivery_boy_details();
                setInputUser({
                    ...inputUser,
                    firstname: "",
                    lastname: "",
                    mobile_no: "",
                    password: "",
                    user_profile: "",
                })

                toast.success("Delivery Boy Added Successfully");
                add_close_Ref.current.click();
            }
        } catch (error) {
            console.error("Add user API error:", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };


    //fetch delivery_boy details
    const fetch_delivery_boy_details = async () => {
        setLoader(true);
        try {
            const res = await get_user_details({ user_type: "delivery_boy" });
            if (res.status === 200) {
                setDeliveryBoy(res.data.data);
            }
            if (inputUser.user_profile === "") {
                setFileListIns([])
            }
            setLoader(false);
        } catch (error) {
            console.error("User details API error:", error);
        }
    };


    // Delete user
    const confirmDelete = async (userId) => {
        if (window.confirm("Are you sure you want to delete this Delivery Boy?")) {
            try {
                const res = await user_delete_api(userId);
                if (res.status === 200) {
                    toast.success("Delivery Boy deleted successfully");
                    fetch_delivery_boy_details();
                }
            } catch (error) {
                console.error("User delete error", error);
            }
        }
    };


    // user profile update
    const uploadButton = (
        <button style={{ border: 0, background: "none" }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );

    const thumb_Before_upload = (file) => {
        const isImage = file.type.startsWith("image/");
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isImage || !isLt3M) {
            return Upload.LIST_IGNORE;
        }
        file.url = URL.createObjectURL(file);
        setInputUser({
            ...inputUser,
            user_profile: file,
        });
        setFileListIns([file]);
        return false;
    };


    const onChangeIns = ({ fileList }) => {
        setFileListIns(fileList);
        setInputUser({ ...inputUser, delete_profile_image: fileList.length < 1 ? true : false })
    };



    // selecte user
    const select_user = (id) => {
        const filter_user = deliveryBoy.filter((user) => user.id == id);
        setInputUser({
            ...filter_user[0], user_id: filter_user[0]?.id
        });

        // view image 
        filter_user[0].user_profile ?
            setFileListIns([
                {
                    uid: '-1',
                    name: 'user_profile',
                    status: 'done',
                    url: `${api.imageUrl}${filter_user[0].user_profile}`,
                },
            ])
            : setFileListIns([])
    };


    // user update
    const user_update_api_call = async () => {
        const { username, mobile_no, } = inputUser
        const errors = {};

        if (!username) {
            errors.username = 'Please Enter Username!'
        }
        if (!mobile_no) {
            errors.mobile_no = 'Please Enter Mobile No!'
        }

        setFormError(errors);

        if (Object.keys(errors).length !== 0) {
            return;
        }
        try {

            const formData = new FormData();
            Object.entries(inputUser).forEach(([key, value]) => {
                formData.append(key, value);
            });

            const res = await user_update_api(formData);
            if (res.status === 200) {
                fetch_delivery_boy_details();
                toast.success("Delivery Boy Updated Successfully");
                update_close_Ref.current.click();
            }
        } catch (error) {
            console.error("User update API error", error);
            if (error.response && error.response.data && error.response.data.errors.length > 0) {
                const errors = {};
                // Map through the errors array and populate the errors object
                error.response.data.errors.forEach(err => {
                    errors[err.key] = err.message; // Assuming each error has 'name' and 'message'
                });
                setFormError(errors);
            }
        }
    };


    //delivery boy active-inactive
    const handle_active_inactive = async (id) => {
        const find_user = deliveryBoy.find((user) => user.id == id);

        const data = {
            username: find_user.username,
            mobile_no: find_user.mobile_no,
            user_id: find_user.id,
            status: deliveryBoyStatus == '1' ? '0' : '1'
        }

        try {
            const res = await user_update_api(data);
            if (res.status === 200) {
                fetch_delivery_boy_details();
                toast.success(`Delivery Boy ${deliveryBoyStatus == '1' ? 'Inactive Successfully' : 'Active Successfully'}`);
            }
        } catch (error) {
            console.error("User update API error", error);
        }
    };


    // copy password to clipboard
    const copy_password = (id) => {
        // Find user in the deliveryBoy array
        const find_user = deliveryBoy.find((user) => user.id == id);

        // Log the find_user to see if it has been retrieved correctly


        // Check if find_user exists and has a password
        if (!find_user || !find_user.password) {
            toast.error('Password not available');
            console.error('Password not found for the user');
            return;
        }

        // Check if the Clipboard API is available
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(find_user.password).then(() => {
                toast.success('Password copied to clipboard!');
            }).catch((err) => {
                console.error('Failed to copy text: ', err);
                toast.error('Failed to copy password');
            });
        } else {
            // Fallback for older browsers or unsupported environments
            const textArea = document.createElement('textarea');
            textArea.value = find_user.password;
            document.body.appendChild(textArea);

            // Select and copy the password
            textArea.select();
            try {
                // Try to copy using execCommand
                const successful = document.execCommand('copy');
                if (successful) {
                    toast.success('Password copied to clipboard!');
                } else {
                    toast.error('Failed to copy password');
                }
            } catch (err) {
                console.error('Fallback failed: ', err);
                toast.error('Failed to copy password');
            } finally {
                // Remove the textarea from the DOM after use
                document.body.removeChild(textArea);
            }
        }
    };


    // data table 
    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Destroy any existing DataTable instance before initializing a new one
        if ($.fn.DataTable.isDataTable(tableId)) {
            table.DataTable().destroy();
        }

        // Initialize DataTable with scrollX for horizontal scrolling
        table.DataTable({
            paging: true,
            lengthChange: true,
            pageLength: 10,
            lengthMenu: [5, 10, 15, 20],
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            infoFiltered: "(filtered from _MAX_ total records)",
            // buttons: ['copy', 'excel', 'pdf', 'print'],
            // dom: 'Bfrtip',
            pagingType: 'full_numbers', // Pagination with full numbers
            language: {
                paginate: {
                    first: '«',
                    last: '»',
                    next: '›',
                    previous: '‹',
                }
            },
            drawCallback: function (settings) {
                const api = this.api();
                const info = api.page.info();
                const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
                const currentPage = info.page;
                const totalPages = info.pages;

                // Show only specific pages with ellipses
                $paginate.each(function (index) {
                    const pageIndex = parseInt($(this).text(), 10) - 1;
                    if (isNaN(pageIndex)) return; // Skip non-number buttons

                    if (
                        pageIndex === 0 ||
                        pageIndex === totalPages - 1 ||
                        (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
                    ) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                // Add ellipses if necessary
                if (currentPage > 2) {
                    $('<span class="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
                }
                if (currentPage < totalPages - 3) {
                    $('<span class="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
                }
            }
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [filterDeliveryBoyData]);


    const clearError = () => {
        const clearedErrors = {};

        Object.keys(formError).forEach(field => {
            clearedErrors[field] = "";
        });

        setFormError(clearedErrors);
    }


    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0 mr-3">Delivery Boy</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Delivery Boy</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column flex-sm-row align-items-end justify-content-end'>
                        <button
                            className='btn btn-naariyal-green mr-0 mr-sm-3'
                            data-toggle="modal"
                            data-backdrop="static"
                            data-target="#add-user"
                            onClick={() => {
                                setInputUser({
                                    ...inputUser,
                                    username: "",
                                    user_id: "",
                                    firstname: "",
                                    lastname: "",
                                    mobile_no: "",
                                    email: "",
                                    password: "",
                                    user_profile: "",
                                })
                            }}
                        >
                            <i className="fas fa-plus mr-2"></i>
                            Add Delivery Boy
                        </button>

                        <button
                            type='button'
                            className={`btn btn-naariyal-${deliveryBoyStatus == '0' ? 'green' : 'red'} mt-3`}
                            onClick={change_deliver_boy_status}
                        >
                            {deliveryBoyStatus == '0' ? ' Active Delivery Boys' : 'Inactive Delivery Boys'}
                        </button>
                    </div>
                </div>


                {
                    loader ? <Loader /> : (
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">

                                        <div className="card">
                                            <div className="card-body">
                                                <div className='table-responsive'>
                                                    <table id="example2" className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Username</th>
                                                                <th>Name</th>
                                                                <th>Mobile No</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                filterDeliveryBoyData.length > 0 && filterDeliveryBoyData.map((boy, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{boy?.username}</td>
                                                                        <td>{boy?.firstname + ' ' + boy?.lastname}</td>
                                                                        <td>{boy?.mobile_no}</td>
                                                                        <td>
                                                                            <div className="btn-group">
                                                                                <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>

                                                                                <div className="dropdown-menu" role="menu">
                                                                                    {
                                                                                        deliveryBoyStatus == '0' ?

                                                                                            <a
                                                                                                className="dropdown-item text-success"
                                                                                                onClick={() => { handle_active_inactive(boy?.id) }}
                                                                                            >
                                                                                                {deliveryBoyStatus == '0' ? ' Active' : 'Inactive'}
                                                                                            </a> :
                                                                                            <>
                                                                                                <a
                                                                                                    className="dropdown-item text-success"
                                                                                                    onClick={() => copy_password(boy?.id)}
                                                                                                >
                                                                                                    <i className="fa-solid fa-copy mr-2"></i>
                                                                                                    Copy Password
                                                                                                </a>
                                                                                                <div className="dropdown-divider"></div>
                                                                                                <Link
                                                                                                    to="/permissions"
                                                                                                    className="dropdown-item text-warning"
                                                                                                    state={{ userId: boy?.id }}
                                                                                                >
                                                                                                    <i className="fa-solid fa-handshake-simple mr-2"></i>
                                                                                                    Permissions
                                                                                                </Link>
                                                                                                <div className="dropdown-divider"></div>
                                                                                                <a
                                                                                                    className="dropdown-item text-info"
                                                                                                    data-toggle="modal"
                                                                                                    data-backdrop="static"
                                                                                                    data-target="#update_user"
                                                                                                    onClick={() => select_user(boy?.id)}
                                                                                                >
                                                                                                    <i className="nav-icon fas fa-pencil mr-2"></i>
                                                                                                    Update
                                                                                                </a>
                                                                                                <div className="dropdown-divider"></div>
                                                                                                <a
                                                                                                    className="dropdown-item text-danger"
                                                                                                    onClick={() => { handle_active_inactive(boy?.id) }}
                                                                                                >
                                                                                                    <i className="nav-icon fa-solid fa-ban mr-2"></i>
                                                                                                    {deliveryBoyStatus == '0' ? ' Active' : 'Inactive'}
                                                                                                </a>
                                                                                            </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* add user modal */}
                            <div className="modal fade" id="add-user" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>Add Delivery Boy</h5>
                                            <button type="button" className="close" onClick={clearError} data-dismiss="modal" aria-label="Close" ref={add_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="input-group">

                                                <div className='d-flex'>
                                                    <div className='w-100 mb-3 mr-2'>
                                                        <label htmlFor="firstname">First Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter First Name"
                                                            id='firstname'
                                                            name='firstname'
                                                            value={inputUser?.firstname}
                                                            onChange={handle_change}
                                                            onBlur={generate_user_name}
                                                        />

                                                    </div>
                                                    <div className='w-100 mb-3'>
                                                        <label htmlFor="lastname">Last Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Last Name"
                                                            id='lastname'
                                                            name='lastname'
                                                            value={inputUser?.lastname}
                                                            onChange={handle_change}
                                                            onBlur={generate_user_name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="username">
                                                        Username
                                                        <span className='text-danger'>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control text-lowercase"
                                                        placeholder="Enter Username"
                                                        id='username'
                                                        name='username'
                                                        value={inputUser?.username}
                                                        onChange={handle_change}
                                                        onBlur={generate_user_name}
                                                    />
                                                    <FormError>
                                                        {formError.username ? formError.username : ''}
                                                    </FormError>
                                                </div>

                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="mobile_no">
                                                        Mobile No
                                                        <span className='text-danger'>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Mobile No"
                                                        id='mobile_no'
                                                        name='mobile_no'
                                                        value={inputUser?.mobile_no}
                                                        onChange={handle_change}
                                                    />
                                                    <FormError>
                                                        {formError.mobile_no ? formError.mobile_no : ''}
                                                    </FormError>
                                                </div>
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="password">
                                                        Password
                                                        <span className='text-danger'>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Password"
                                                        id='password'
                                                        name='password'
                                                        value={inputUser?.password}
                                                        onChange={handle_change}
                                                        ref={input_password_Ref}
                                                    />
                                                    <div>
                                                        <FormError>
                                                            {formError.password ? formError.password : ''}
                                                        </FormError>
                                                    </div>
                                                    <button
                                                        className="btn btn-warning btn-sm mt-2"
                                                        onClick={generateRandomNumber}
                                                    >
                                                        Generate Password
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">
                                            <button
                                                type="button"
                                                className="btn btn-naariyal-green w-25 m-auto"
                                                onClick={add_user_api_call}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* update user modal */}
                            <div className="modal fade" id="update_user" tabIndex={-1} role="dialog" aria-labelledby="addCityModal" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header border-0">
                                            <h5>
                                                Update Details
                                            </h5>
                                            <button type="button" className="close" onClick={clearError} data-dismiss="modal" aria-label="Close" ref={update_close_Ref}>
                                                <span aria-hidden="true">×</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">

                                            <Upload
                                                className='mb-3 m-auto'
                                                style={{ width: "fit-content", margin: "auto" }}
                                                beforeUpload={thumb_Before_upload}
                                                accept=".jpg,.png,.jpeg"
                                                listType="picture-circle"
                                                fileList={fileListIns}
                                                onChange={onChangeIns}
                                            >
                                                {fileListIns.length >= 1 ? null : uploadButton}
                                            </Upload>

                                            <div className="input-group">
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="username">Username</label>
                                                    <input
                                                        type="text"
                                                        className="form-control text-lowercase"
                                                        placeholder="Enter Username"
                                                        id='username'
                                                        name='username'
                                                        value={inputUser?.username}
                                                        onChange={handle_change}
                                                    />
                                                    <FormError>
                                                        {formError.username ? formError.username : ''}
                                                    </FormError>
                                                </div>
                                                <div className='d-flex'>
                                                    <div className='w-100 mb-3 mr-2'>
                                                        <label htmlFor="firstname">First Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter First Name"
                                                            id='firstname'
                                                            name='firstname'
                                                            value={inputUser?.firstname}
                                                            onChange={handle_change}
                                                        />
                                                    </div>
                                                    <div className='w-100 mb-3'>
                                                        <label htmlFor="lastname">Last Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Last Name"
                                                            id='lastname'
                                                            name='lastname'
                                                            value={inputUser?.lastname}
                                                            onChange={handle_change}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="mobile_no">Mobile No</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Mobile No"
                                                        id='mobile_no'
                                                        name='mobile_no'
                                                        value={inputUser?.mobile_no}
                                                        onChange={handle_change}
                                                    />
                                                    <FormError>
                                                        {formError.mobile_no ? formError.mobile_no : ''}
                                                    </FormError>
                                                </div>
                                                <div className='w-100 mb-3'>
                                                    <label htmlFor="email">Email Id</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Email Id"
                                                        id='email'
                                                        name='email'
                                                        value={inputUser?.email}
                                                        onChange={handle_change}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer border-0">
                                            <button
                                                type="button"
                                                className="btn btn-naariyal-green w-25 m-auto"
                                                onClick={user_update_api_call}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>
                    )
                }
            </div>
            <Footer />
        </div>
    );
}

export default DeliveryBoy;
